import { Component } from "react";
import { injectIntl } from "react-intl";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import React from "react";

import { Card, Row, Col, Table } from "antd";
import moment from "moment";
import BunkeyAPI from "../../api/BunkeyAPI";
import {
  handleMineOrAll,
  handleDefaultListDownloadHistory,
  handleRefreshDownloadHistory,
  handleIsFetchingHistory
} from "../../actions/DownloadAction";
import { getSearchResult } from "../../actions/SearchAction";
import "./dashboard-login.css";
import { setCpActivityLogSelectedValue } from "../../actions/AppAction";

export class DashboardLogin extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.columns = [
      {
        title: intl.formatMessage({ id: "user" }),
        key: "name",
        dataIndex: "name"
      },
      {
        title: intl.formatMessage({ id: "email" }),
        key: "email",
        dataIndex: "email"
      },
      {
        title: intl.formatMessage({ id: "date_range" }),
        key: "createdAt",
        render: ({ createdAt }) =>
          `${moment(createdAt).format("DD-MM-YYYY HH:mm:ss")} Hrs`
      }
    ];
    const limit = 10;
    this.state = {
      searchInClient: false,
      isFetchingLoginLocal: true,
      autoRefresh: {
        pidFetch: null,
        pidTime: null,
        count: 0,
        percent: 0,
        on: false
      },
      filter: {
        clientType: "all",
        businessType: "all",
        client_name: "",
        user_email: "",
        user_name: "",
        action: "all",
        dateRange: null,
        modules: {
          sistemasDeGrupos: false,
          commentsAndVersions: false,
          BunkeyHost: false,
          MFA: false
        }
      },
      page: 1,
      count: 0,
      limit: limit,
      orderBy: "createdAt",
      orderDir: "desc",
      clients: [],
      data: [],
      options: [],
      optionsUser: [],
      colorCreationdate: "",
      paginationColor: {
        10: limit === 10 ? "#eaeaea" : "",
        20: limit === 20 ? "#eaeaea" : "",
        40: limit === 40 ? "#eaeaea" : "",
        60: limit === 60 ? "#eaeaea" : "",
        80: limit === 80 ? "#eaeaea" : "",
        100: limit === 100 ? "#eaeaea" : ""
      },
      iconPaginationColor: {
        10: limit === 10,
        20: limit === 20,
        40: limit === 40,
        60: limit === 60,
        80: limit === 80,
        100: limit === 100
      }
    };
  }

  componentDidMount() {
    this.handleGetData();
  }
  handleShowActivityLog = () => {
    this.props.setCpActivityLogSelectedValue("userAccessClient");
    this.props.history.push("/home/activity-log");
  };
  handleGetData = () => {
    const { page, limit, orderBy, orderDir } = this.state;
    let query = [];
    let order = {
      field: [orderBy],
      type: orderDir,
      limit: limit,
      page: page
    };

    query = [
      ...query,
      {
        field: "action",
        type: "eq",
        value: "userAccessClient"
      }
    ];

    if (query.length > 0) {
      BunkeyAPI({
        url: `/logs?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`,
        method: "GET"
      })
        .then(resp => {
          if (resp.status === 200) {
            this.setState({
              data: resp.data,
              limit: parseInt(resp.headers["x-pagination-limit"]),
              count: parseInt(resp.headers["x-pagination-total-count"]),
              isFetchingLoginLocal: false,
              searchInClient: false
            });
          }
        })
        .catch(err => {
          console.log("error: ", err);
        });
    } else {
    }
  };

  render() {
    const { intl, user } = this.props;
    const hash = "#";

    const { data, isFetchingLoginLocal } = this.state;
    const isAdmin = user && user.clientRole && user.clientRole === "admin" && user.role !== "admin" ? true : false;
    return (
      <React.Fragment>
        {/* activity_log */}
        <Card
          className="dashboard-login"
          title={intl.formatMessage({ id: "cp-signIn-user" })}
          extra={!isAdmin &&
            <a href={hash} onClick={this.handleShowActivityLog}>
              <svg
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5361 2.33188C10.8392 0.513713 13.5756 0.285597 15.6778 1.81988C17.532 3.62756 17.7629 6.34708 16.1967 7.92914L8.49177 17.0977C8.10763 17.5766 7.56773 17.9113 6.94009 18.0597L2.40716 19.1012C2.05898 19.2072 1.65 19.1105 1.33827 18.8486C1.02654 18.5866 0.860906 18.2004 0.905379 17.8392L1.1508 13.1946C1.19532 12.553 1.43142 11.9652 1.83122 11.5004L9.5361 2.33188ZM5.19794 14.2672C5.67279 14.6663 6.64667 14.289 7.37315 13.4245L13.4416 6.2032C13.795 5.78897 14.0428 5.31224 14.1286 4.88137C14.2144 4.45051 14.131 4.10211 13.8972 3.91536C13.4224 3.51632 12.4485 3.89364 11.722 4.75813L5.65356 11.9794C4.92708 12.8439 4.72309 13.8682 5.19794 14.2672Z"
                  fill="#3598CD"
                />
              </svg>
            </a>
          }
          hoverable
          style={{ minHeight: "295px" }}
        >
          <Row>
            <Col span={24}>
              <div
                className="css-color-bunkers-login-table"
                style={{
                  overflow: "auto",
                  overflowX: "hidden",
                  maxHeight: "332px",
                  scrollbarTrackColor: "white",
                  marginTop: "0px",
                  paddingRight: "10px"
                }}
              >
                <div className="table-responsive">
                  <Table
                    className="table-dashboard-login"
                    rowKey="_id"
                    loading={isFetchingLoginLocal}
                    bordered
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? "row-opacity" : ""
                    }
                    columns={this.columns}
                    dataSource={data}
                    pagination={false}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    defaultListDownloadHistory: state.downloads.defaultListDownloadHistory,
    user: state.authUser.user,
    isFetchingHistory: state.downloads.isFetchingHistory,
    mine: state.downloads.mine,
    breadcrumb: state.client.breadcrumb,
    root: state.client.root,
    workclient: state.client.workclient,
    refreshDownloadHistory: state.downloads.refreshDownloadHistory
  };
};

const mapDispatchToProps = {
  handleMineOrAll,
  getSearchResult,
  handleDefaultListDownloadHistory,
  handleRefreshDownloadHistory,
  handleIsFetchingHistory,
  setCpActivityLogSelectedValue
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardLogin))
);
